define.alias("shared/utils/redirect", "calendar/utils/redirect");